import type { AvailableDateResult } from '@VelocitySquared/cady-sunny16-commerce-integration-models'

export enum SchedulingLocationToggleType {
  Studio = 'studio',
  School = 'school'
}

/**
 * Bundled scheduling availability — the date records and their per-date display prices
 * always travel together so consumers can't see one without the other.
 */
export interface DateAvailability {
  dates: AvailableDateResult[]
  priceMap: Record<string, number>
}
